<template>
  <div class="row" v-loading="loading">
    <div class="col-12" v-if="closeouts.length == 0">
      <small v-if="closeoutForm.error" class="text-danger">{{
        closeoutForm.message
      }}</small>
      <div class="row">
        <div class="col-12 font-weight-bold label-field">
          Settlement Date <span class="required-flag">*</span>
        </div>
        <div class="col-12 mb-2">
          <el-date-picker
            v-model="closeoutForm.settlement_date"
            value-format="yyyy-MM-dd"
            format="dd/MM/yyyy"
            type="date"
            class="w-50"
            placeholder="Pick a settlement date"
            :picker-options="pickerOptions"
            @change="getRefinanceValues"
          ></el-date-picker>
        </div>
      </div>

      <div class="row pt-2 py-1 border-bottom font-weight-bold">
        <div class="col-2">Trade #</div>
        <div class="col-5 text-center">Original Avg Weight</div>
        <div class="col-5 text-center">Current Avg Weight</div>
      </div>
      <div
        class="row border-bottom small-ui py-1"
        v-for="lineItem in closeoutForm.line_items"
        :key="lineItem.id"
      >
        <div class="col-2">{{ lineItem.description }}</div>
        <div class="col-5 text-center">{{ lineItem.curr_average_weight }}</div>
        <div class="col-5 text-center">
          <currency-input
            v-model="lineItem.average_weight"
            class="w-50"
            :precision="2"
            :currency="null"
          />
        </div>
      </div>

      <div class="row my-3" v-if="closeoutForm.settlement_date">
        <div class="col-12">
          <span class="font-weight-bold label-field"
            >Livestock Balance (ex) :</span
          >
          ${{ $_toLocaleString(livestock_balance_ex) }}
        </div>
      </div>
      <div class="row my-3">
        <div class="col-12">
          <div class="font-weight-bold label-field">Additional documents</div>
          <div class="">
            <el-upload
              action
              ref="sale_invoice"
              :file-list="additionalFiles"
              :multiple="true"
              :limit="3"
              :auto-upload="false"
              :on-exceed="handleExceed"
              :on-change="handleUpload"
              :on-remove="handleRemove"
            >
              <el-button size="small" type="primary">Select files</el-button>
            </el-upload>
          </div>
        </div>
      </div>

      <div class="row">
        <div
          class="col-12 d-flex align-items-center justify-content-between w-100 mt-3"
        >
          <div>
            <el-button class="btn-secondary" @click="$emit('close')"
              >Cancel</el-button
            >
          </div>
          <div>
            <el-button class="btn-secondary" @click="$emit('back')"
              >Previous</el-button
            >
            <el-button
              class="btn-primary"
              @click="onSubmit"
              :disabled="closeoutForm.error"
              >Send</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-else-if="show_closeouts">
      <closeout-purchase-list
        :closeouts="closeouts"
        @close="$emit('close')"
      ></closeout-purchase-list>
    </div>
  </div>
</template>

<script>
import Formatter from "../mixins/OttleyFormatter";
import CloseoutPurchase from "../frontend/modelsPortal/common/CloseoutPurchase.js";
import CloseoutPurchaseList from "./CloseoutPurchaseList.vue";
export default {
  components: { CloseoutPurchaseList },
  mixins: [Formatter],
  props: {
    closeout_purchases: {
      type: Array,
    },
    invoice_file: {
      type: Array,
    },
    initial_closeout_form: {
      type: Object,
    },
    show_closeouts: {
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
      additionalFiles: [],
      closeoutForm: this.initial_closeout_form,
      refinanceValues: [],
      closeouts: [],
    };
  },
  computed: {
    pickerOptions() {
      let self = this;
      return {
        disabledDate(time) {
          let min = null;
          if (self.closeout_purchases.length > 0) {
            let invoiceDueDates = self.closeout_purchases.map(
              ({ invoice_due_date }) => invoice_due_date,
            );
            min = invoiceDueDates.reduce(function (a, b) {
              return a < b ? a : b;
            });
          }

          return (
            time.getTime() <= Date.now() ||
            [0, 6].includes(time.getDay()) ||
            (min && time.getTime() > moment(min))
          );
        },
      };
    },
    livestock_balance_ex() {
      let self = this;
      return this.refinanceValues.reduce(function (prev, curr) {
        let purchase = self.closeout_purchases.find((id) => curr.purchase_id);
        return (
          prev +
          Number(
            (curr.livestock_balance_ex_gst / purchase.open_head) *
              purchase.on_pic,
          )
        );
      }, 0);
    },
  },
  mounted() {
    this.getRefinanceValues();
  },
  methods: {
    getRefinanceValues() {
      self = this;
      self.refinanceValues = [];
      self.closeoutForm.error = false;
      self.closeoutForm.message = "";
      if (self.closeoutForm.settlement_date) {
        this.loading = true;
        let data = {
          settlement_date: self.closeoutForm.settlement_date,
          purchase_ids: self.closeout_purchases.map(({ id }) => id),
        };
        axios
          .post(`/api/v2/closeout-purchases/refinance-values`, data)
          .then((res) => {
            if (res.data.length == self.closeout_purchases.length) {
              self.refinanceValues = res.data;
            } else {
              self.closeoutForm.error = true;
              self.closeoutForm.message =
                "We could not calculate the values to refinance, please contact Ottley";
            }
          })
          .catch((errors) => {
            console.log(errors);
          })
          .finally((_) => {
            self.loading = false;
          });
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(`You can upload 3 files`);
    },
    handleUpload(file) {
      this.additionalFiles.push(file);
    },
    handleRemove(file) {
      this.additionalFiles.splice(file, 1);
    },
    calculateLineItemsValues() {
      let self = this;
      this.refinanceValues.forEach((item) => {
        let closeoutPurchase = self.closeout_purchases.find(
          (cp) => cp.id == item.purchase_id,
        );
        let total = Number(
          (item.livestock_balance_ex_gst / closeoutPurchase.open_head) *
            closeoutPurchase.on_pic,
        );

        let lineItem = self.closeoutForm.line_items.find(
          (lt) => lt.closeout_purchase_id == item.purchase_id,
        );
        lineItem.total_ex_gst = total;
        lineItem.price_per_head_ex_gst = self.$_roundAccurately(
          lineItem.total_ex_gst && lineItem.quantity
            ? lineItem.total_ex_gst / lineItem.quantity
            : 0,
          4,
        );
        lineItem.price_per_kg_ex = self.$_roundAccurately(
          lineItem.total_ex_gst && lineItem.quantity && lineItem.average_weight
            ? lineItem.total_ex_gst /
                lineItem.quantity /
                lineItem.average_weight
            : 0,
          4,
        );
      });
    },
    appendArray(formData, values, name) {
      if (!values && name) formData.append(name, "");
      else {
        if (typeof values == "object") {
          for (let key in values) {
            if (typeof values[key] == "object")
              this.appendArray(formData, values[key], name + "[" + key + "]");
            else formData.append(name + "[" + key + "]", values[key]);
          }
        } else formData.append(name, values);
      }

      return formData;
    },
    onSubmit() {
      if (this.closeoutForm.error) {
        this.$message({
          type: "error",
          message: "Something went wrong, please contact Ottley to refinance",
        });
      }
      this.calculateLineItemsValues();

      this.loading = true;

      this.closeoutForm.average_weight = (
        this.closeoutForm.line_items.reduce(
          (sum, item) => sum + Number(item.average_weight),
          0,
        ) / this.closeoutForm.line_items.length
      ).toFixed(2);

      // if (!this.closeoutForm.invoice_invoice_date)
      this.closeoutForm.invoice_invoice_date =
        this.closeoutForm.settlement_date;

      // if (!this.closeoutForm.bill_due_date)
      this.closeoutForm.bill_due_date = this.closeoutForm.settlement_date;

      this.closeoutForm.settlement_date = this.closeoutForm.settlement_date;
      /*this.closeoutForm.additional_files = additionalFiles;

      if (this.invoice_file.length > 0)
        this.closeoutForm.sale_invoice = this.invoice_file[0].raw;*/

      new CloseoutPurchase(this.closeoutForm)
        .save()
        .then(async (res) => {
          let closeouts = Object.values(res);
          await this.uploadDocuments(closeouts);
          this.closeouts = closeouts;
          this.$message.success(`Closeout request sent`);
          this.$emit("refresh");
          if (!this.show_closeouts) {
            this.$emit("close");
          }
        })
        .catch((errors) => {
          console.log(errors);
          var errorText = [];
          _.forEach(errors.response.data.errors, function (value) {
            errorText.push(value[0]);
          });
          errorText = [...new Set(errorText)];
          this.$message({ type: "error", message: errorText.join(" ") });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    uploadDocuments(closeouts) {
      if (this.additionalFiles.length == 0 && this.invoice_file.length == 0)
        return true;

      let form_data = new FormData();
      if (this.additionalFiles.length > 0) {
        this.additionalFiles.forEach((file) => {
          form_data.append("additional_files[]", file.raw);
        });
      }

      if (this.invoice_file.length > 0)
        form_data.append("sale_invoice", this.invoice_file[0].raw);

      closeouts.forEach((element) => {
        form_data.append("closeout[]", element.id);
      });

      return axios
        .post(`/api/v2/closeout-purchases/upload`, form_data, {
          headers: { "content-type": "multipart/form-data" },
        })
        .then((res) => {
          this.additionalFiles = [];
          this.invoice_file = [];
        })
        .catch((errors) => {
          this.$message({
            type: "error",
            message:
              "Looks like something went wrong with documents uploaded please contact Ottley.",
          });
        });
    },
  },
};
</script>
